import React from "react";
import { Avatar, Menu, MenuButton } from "@chakra-ui/react";
import { CurrentUserPopup } from "./components/CurrentUserPopup";
import { colours } from "@/utils/themeUtils";

export function UserSessionDropdown(): JSX.Element {
	return (
		<Menu>
			<MenuButton className="user-icon" aria-label="User Settings">
				<Avatar size="sm" bg={colours.neutrals[300]} color={colours.neutrals[50]} border={"2px solid rgba(255, 255, 255, 0.7)"} />
			</MenuButton>
			<CurrentUserPopup />
		</Menu>
	);
}
